<div class="ps">
  @if (!creditCardsEnabled) {
    <div class="container-info">
      @if (!isMobile) {
        <div class="info-box border-info-box mb-20" role="alert">{{
          "deposit_visa_cc_info" | translate
        }}</div>
      }
      @if (isMobile) {
        <div class="info-box border-info-box mb-20" role="alert">
          <div class="info-box-mobile-header">{{ "deposit_visa_cc_mobile_info_header" | translate }} </div>
          <div>{{ "deposit_visa_cc_mobile_info" | translate }} </div>
        </div>
      }
    </div>
  }
  <div class="form-group" [class.has-error]="cardNumberField.isInvalid && cardNumberField.isTouched">
    <label for="card-number" class="ps-input-field-label">{{ "card_number" | translate }}</label>
    <div
      class="ps-input-field"
      id="card-number"
      [class.mastercard]="cardNumberField.creditCardType === 'mastercard'"
    [class.visa]="cardNumberField.creditCardType === 'visa'"></div>
    @if (cardNumberField.isInvalid && cardNumberField.isTouched) {
      <span class="form-error">
        @if (cardNumberField.cardBrandValid) {
          {{ cardNumberField.secondaryErrorI18nKey | translate }}
        } @else {
          {{ cardNumberField.errorI18nKey | translate }}
        }
      </span>
    }
  </div>

  <div
    class="form-group"
    [formGroup]="nameForm"
    [class.has-error]="(cardHolderNameField.invalid && cardHolderNameField.touched) || ccNamePasteErrorActive">
    <label for="cardholder-name" class="ps-input-field-label">{{ "name_on_card" | translate }}</label>
    <input
      class="card-input-field ps-input-field"
      id="cardholder-name"
      [placeholder]="'name_on_card' | translate"
      [class.has-error]="cardHolderNameField.invalid && cardHolderNameField.touched"
      formControlName="cardHolder"
      (keypress)="handleCardHolderKeypress($event)"
      (change)="handleCardHolderChange()"
      (paste)="handleCardHolderPaste($event)" />
    @if (cardHolderNameField.invalid && cardHolderNameField.touched) {
      @if (cardHolderNameField.hasError('pattern')) {
        <span class="form-error">{{
          "paysafe_name_on_card_pattern_error" | translate
        }}</span>
      }
      @if (cardHolderNameField.hasError('minlength')) {
        <span class="form-error">{{
          "paysafe_name_on_card_min_length_error" | translate
        }}</span>
      }
      @if (cardHolderNameField.hasError('maxlength')) {
        <span class="form-error">{{
          "paysafe_name_on_card_max_length_error" | translate
        }}</span>
      }
      @if (cardHolderNameField.hasError('required')) {
        <span class="form-error">{{
          "required_field_error" | translate
        }}</span>
      }
    }
    @if (ccNamePasteErrorActive) {
      <span class="form-error">{{
        "paysafe_name_on_card_paste_error" | translate
      }}</span>
    }
  </div>
  <div class="ps-input-group">
    <div class="form-group" [class.has-error]="expiryDateField.isInvalid && expiryDateField.isTouched">
      <label for="expiry-date" class="ps-input-field-label">{{ "expiration_date" | translate }}</label>
      <div class="ps-input-field ps-input-field__short" id="expiry-date"></div>
      @if (expiryDateField.isInvalid && expiryDateField.isTouched) {
        <span class="form-error">{{ expiryDateField.errorI18nKey | translate }}</span>
      }
    </div>
    <div class="form-group" [class.has-error]="cvvField.isInvalid && cvvField.isTouched">
      <label for="cvv" class="ps-input-field-label">{{ "cvv" | translate }}</label>
      <div class="ps-input-field ps-input-field__short" id="cvv"></div>
      @if (cvvField.isInvalid && cvvField.isTouched) {
        <span class="form-error">{{ cvvField.errorI18nKey | translate }}</span>
      }
    </div>
  </div>

  <ng-content select="[saveSwitch]"></ng-content>

  @if (errors$ | async; as errors) {
    <bp-error-box>
      @for (error of errors; track error) {
        {{ error }}
      }
    </bp-error-box>
  }

  <button #payNow class="ps-continue-button btn" [disabled]="buttonDisabled | async" type="button">
    {{ buttonText$ | async | translate }}
  </button>
</div>
